




















import { Component, Mixins } from 'vue-mixin-decorator';
// import { Component, Vue } from 'vue-property-decorator';
import { SlotMixin } from '@/mixins/SlotMixin';
import PublicLayout from '@/views/layouts/PublicLayout.vue';
import { Enterprise } from '@/store/types/public/Enterprise';
import Pagination from '@/components/Pagination.vue';
import EnterpriseCard from '@/components/enterprise/EnterpriseCard.vue';
import { namespace } from 'vuex-class';
import { NAMESPACE } from '@/store/models/pub/enterprises';
import { GET_ITEMS, ITEMS_REQUEST, LOADING } from '@/store';

const enterpriseStore = namespace(NAMESPACE);
@Component({
  components: { EnterpriseCard, Pagination, PublicLayout }
})
export default class EnterprisesIndex extends Mixins<SlotMixin>(SlotMixin) {
  @enterpriseStore.Getter(GET_ITEMS) enterprises!: Enterprise[];
  @enterpriseStore.Getter(LOADING) loading!: boolean;
  @enterpriseStore.Action(ITEMS_REQUEST) getItems:any;

  created () {
    this.getItems();
    this.$gtag.event('page_view', { screen_name: 'Список підприємств' });
  }
}
